import { makeStyles } from "@material-ui/core";
import { useEvent, useIO, useLinked } from "@type-r/react";
import { Column, Columns, Flex, FormCheckbox, FormInput, FormSelect, Loading, Option, ReadOnly, Toolbar } from "lqx-react/lib";
import React, { useEffect } from "react";
import { RelationshipModel } from "api/relationship";
import { MultiEmailInput } from "../../../../../common/emails";
import { MultiItemInput } from "../../../../../common/multi-item-input";
import { CpSaveButton } from "../common/api";
import { Events } from "@type-r/models";

export const CpPaymentOfRaProfile = ({ $selected, canEdit }: {
    $selected: RelationshipModel,
    canEdit: Boolean
}) => {
    const classes = useStyles();
    const payment = $selected.cpPayment;
    
    const frequencyOfPayment = ['Bi-Weekly', 'Cash in Advance', 'Monthly', 'On Due Date', 'Weekly'];
    const methodOfPayment = ['ACH / PE-ACH', 'Check / Lockbox', 'Direct Deposit', 'P-Card/Credit Card/Letter Card', 'Wire / LCTO', 'Other'];
    const paymentReference = ['Commercial Invoice', 'Fiscal Invoice', 'Invoice Number', 'PO Number', 'Reference A', 'SBI', 'VAT'];
    const paymentConfirmationType = ['Email', 'Bank Statement', 'Site', 'Web-site'];
    
    const isPaymentFormEnabled = useLinked(false);
    const isReadOnly = useLinked(false);

    const loadData = async () => {
        await $selected.cpPayment.fetch().catch(onError);
    }
    const isReady = useIO(loadData, []);

    useEvent(Events, "cpImport:done", loadData);

    const save = async () => {        
        await $selected.cpPayment.save();
    }

    const onError = (e) => {
        console.error(e);
    }

    useEffect(() => {
        isPaymentFormEnabled.set(payment.reconciliationOfPayments);
        isReadOnly.set(!canEdit || !payment.reconciliationOfPayments);
    }, [payment.reconciliationOfPayments]);

    return (
        isReady ? <>
            <ReadOnly.Provider value={ !canEdit || !payment.reconciliationOfPayments }>
                <Columns className={ classes.container }>
                    <Column>
                        <FormCheckbox label="Reconciliation of Payments" $checked={payment.$.reconciliationOfPayments} readOnly={!canEdit} />
                        <FormCheckbox label="Auto Book Payments" $checked={payment.$.autoBookPayments} readOnly={isReadOnly.value} />
                        <FormInput label="Payment on Behalf" $value={payment.$.paymentOnBehalf} placeholder="ex. OriginalAssetObligor.Name" />
                        <FormCheckbox label="Remittance Advice Not Required" $checked={payment.$.remittanceAdviceNotRequired} readOnly={isReadOnly.value} />
                        <FormCheckbox label="Send to PTS" $checked={payment.$.sendToPTS} readOnly={isReadOnly.value} />
                        <FormCheckbox label="Send amount to payor" $checked={payment.$.amountSendToPayor} readOnly={isReadOnly.value} />
                        <FormCheckbox label="Disable negative adjustments" $checked={payment.$.disableNegativeAdjustments} readOnly={isReadOnly.value} />
                        <FormCheckbox label="Amount Settle off Platform" $checked={payment.$.amountSettleOffPlatform} readOnly={isReadOnly.value} />
                        <FormInput label="Customer ID" $value={payment.$.customerId} />
                        <FormInput label="Bank Name" $value={payment.$.bankName} />
                        <MultiItemInput $items={payment.$.bankAccountNumber as any} label={'Bank Account Number'} trailingCharsCount={4} />
                        <FormInput label="Bank Currency" $value={payment.$.bankCurrency} />
                        <FormInput label="ZBA Name" $value={payment.$.zbaName} />
                    </Column>
                    <Column>
                        <FormSelect label="Frequency of Payment" $value={payment.$.frequencyOfPayment} >
                            {frequencyOfPayment.map(f => <Option key={f} value={f}>{f}</Option>)}
                        </FormSelect>
                        <FormInput label="Frequency of Payment Detail" $value={payment.$.frequencyOfPaymentDetail} />
                        <FormSelect label="Method of Payment" $value={payment.$.methodOfPayment} >
                            {methodOfPayment.map(f => <Option key={f} value={f}>{f}</Option>)}
                        </FormSelect>
                        <FormSelect label="Payment Reference" $value={payment.$.paymentReference} >
                            {paymentReference.map(f => <Option key={f} value={f}>{f}</Option>)}
                        </FormSelect>
                        <FormSelect label="Payment Confirmation Type" $value={payment.$.paymentConfirmationType} >
                            {paymentConfirmationType.map(f => <Option key={f} value={f}>{f}</Option>)}
                        </FormSelect>
                        <MultiEmailInput $emails={payment.$.paymentConfirmationDetail as any} label={'Payment Confirmation Detail'} />
                        <Flex grow />
                    </Column>
                </Columns>
            </ReadOnly.Provider>
            <Toolbar>
                <Flex grow />
                {canEdit && <CpSaveButton onClick={save} label={'Save payment and RA information ?'}/>}
            </Toolbar>
        </> : < Loading />
    );
}

const useStyles = makeStyles({
    container : {
        alignItems: "baseline"
    }
});